import { API_URL } from 'constants';

export const DEFAULT_ROLE_URL = `${API_URL}/api/v1/role`;
